// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"fe83ba89","587":"0ef95a46","681":"fe83ba89","719":"281a3b99"}[chunkId] + ".chunk.css";
};